import { enableWith, disableWith } from "./toggleWith";
import { enableFixe, disableFixe } from "./toggleFixe";
import { enableGlob, disableGlob } from "./toggleGlob";

up.compiler(".up_billing", function (element) {
  
  const radioButtons = element.querySelectorAll(
    'input[name="workshop[part_mode]"]'
  );

  const zeroRadio = element.querySelector(
    'input[type="radio"]#workshop_part_zero'
  );
  const libreWithRadio = element.querySelector(
    'input[type="radio"]#workshop_part_with'
  );
  const libreRadio = element.querySelector(
    'input[type="radio"]#workshop_part_libre'
  );
  const fixeRadio = element.querySelector(
    'input[type="radio"]#workshop_part_indiv'
  );
  const globRadio = element.querySelector(
    'input[type="radio"]#workshop_part_glob'
  );

  const euroMinInput = document.getElementById("workshop_part_with_price");
  const euroFixeInput = document.getElementById("workshop_part_indiv_price");
  const euroGlobInput = document.getElementById("workshop_part_glob_price");

  function zeroClicked() {
    disableWith();
    disableFixe();
    disableGlob();
  }
  function libreClicked() {
    disableWith();
    disableFixe();
    disableGlob();
  }
  function libreWithClicked() {
    enableWith();
    disableFixe();
    disableGlob();
  }
  function fixeClicked() {
    disableWith();
    enableFixe();
    disableGlob();
  }
  function globClicked() {
    enableGlob();
    disableWith();
    disableFixe();
  }

  function euroMinClicked() {
    document.getElementById("workshop_part_with").click();
  }

  function euroFixeClicked() {
    document.getElementById("workshop_part_indiv").click();
  }

  function euroGlobClicked() {
    document.getElementById("workshop_part_glob").click();
  }

  euroMinInput.addEventListener("click", euroMinClicked);
  euroFixeInput.addEventListener("click", euroFixeClicked);
  euroGlobInput.addEventListener("click", euroGlobClicked);

  zeroRadio.addEventListener("click", zeroClicked);
  libreWithRadio.addEventListener("click", libreWithClicked);
  libreRadio.addEventListener("click", libreClicked);
  fixeRadio.addEventListener("click", fixeClicked);
  globRadio.addEventListener("click", globClicked);

  function ensureOneChecked() {
    const checkedRadio = Array.from(radioButtons).find(
      (radio) => radio.checked
    );
    if (!checkedRadio) {
      element.querySelector("label[for='workshop_part_zero']").click();
    } else {
      const theId = checkedRadio.getAttribute("id");
      element.querySelector(`label[for='${theId}']`).click();
    }
  }
  ensureOneChecked();

  return () => {
    euroMinInput.removeEventListener("click", euroMinClicked);
    euroFixeInput.removeEventListener("click", euroFixeClicked);
    euroGlobInput.removeEventListener("click", euroFixeClicked);
    zeroRadio.removeEventListener("click", zeroClicked);
    libreWithRadio.removeEventListener("click", libreWithClicked);
    libreRadio.removeEventListener("click", libreClicked);
    fixeRadio.removeEventListener("click", fixeClicked);
    globRadio.removeEventListener("click", globClicked);
  };
});
